import { ReactElement, useState, useEffect, Suspense, lazy } from 'react';

import { getFileExtension } from '@utils/browser';

import { ImageViewer } from './image-viewer';

import { ImageExtension } from '../types/file_extension';

const PDF = lazy(() => import('./PDF'));

export type PreviewerProps = {
  url: string | null;
  paginate?: boolean;
  maxWidth: number;
  parentId: string;
  fallback: ReactElement;
};

export function Previewer({ url, paginate = false, maxWidth, parentId, fallback }: PreviewerProps) {
  const [pdfBlob, setPdfBlob] = useState<Blob | undefined>(undefined);
  const fileExtension = getFileExtension(url)?.toLowerCase();

  useEffect(() => {
    if (fileExtension === 'pdf') {
      fetch(url!)
        .then((res) => res.blob())
        .then((blob) => {
          setPdfBlob(blob);
        });
    }
  }, [fileExtension, url]);

  if (!url || !fileExtension) {
    return fallback;
  }
  if (fileExtension === 'pdf') {
    return (
      <Suspense fallback={<div />}>
        <PDF file={pdfBlob} paginate={paginate} maxWidth={maxWidth} parentId={parentId} />
      </Suspense>
    );
  }
  if (fileExtension in ImageExtension) {
    return <ImageViewer url={url} maxWidth={maxWidth} />;
  }
  return fallback;
}

export default Previewer;
